//export const siteUrl = "https://dev-layf.vac.az/";
var siteUrl = "https://layf.az/";
export default siteUrl;
